import { Container, EditIcon, Infos, PausedBadge, RealEstateButton, UserName, UserPhone } from "./styles";
import { ContactProfileProps } from "./types";

import { ChangeSessionModal } from "components/ChangeSessionModal";
import { EditContactModal } from "components/EditContactModal";
import { MouseEvent, useState } from "react";
import { useTheme } from "styled-components";

import { ContactInfoModal } from "components/ContactInfoModal";
import { TextEllipsis } from "components/TextEllipsis";
import { useCallClientNumbers } from "hooks/fetch/useCallClientNumbers";
import { useContacts } from "hooks/useContacts";
import { Check, Users } from "react-feather";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { useHistory } from "react-router";
import { api } from "services/api";
import { ContactProfileSkeleton } from "./skeleton";
import { handleRequestSuccess } from "utils/Request";
import { handleRequestError } from "utils/Request";

export function ContactProfile({ user, isSelectingContact }: ContactProfileProps) {
  const [isEditContactModalOpen, setIsEditContactModalOpen] = useState(false);
  const [isContactInfoModalOpen, setIsContactInfoModalOpen] = useState(false);
  const [isChangeSessionModalOpen, setIsChangeSessionModalOpen] = useState(false);

  const { selectContact } = useContacts();
  const { data: numbers } = useCallClientNumbers();
  const history = useHistory();

  const currentNumber = numbers?.find(number => number.number_id === user.session);

  function handleGoToRealEstateContacts() {
    if (!user.real_estate_info) return;
    history.push(`/contatos/procurar/serial:${user.real_estate_info.serial}`);
  }

  function handleOpenEditContactModal() {
    setIsEditContactModalOpen(true);
  }

  function handleCloseEditContactModal() {
    setIsEditContactModalOpen(false);
  }

  function handleOpenContactInfoModal(e: MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();
    setIsContactInfoModalOpen(true);
  }

  function handleCloseContactInfoModal() {
    setIsContactInfoModalOpen(false);
  }

  function handleOpenChangeSessionModal() {
    setIsChangeSessionModalOpen(true);
  }

  function handleCloseChangeSessionModal() {
    setIsChangeSessionModalOpen(false);
  }

  function handleCheckRegistration(e: MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();
    api.post(`/contacts/update-external-ids/${user?.id}`)
      .then(({ data }) => {
        handleRequestSuccess(`Checagem concluida!`);
        selectContact(data);
      })
      .catch((res) => handleRequestError(res));
  }

  const theme = useTheme();

  // function handleDeleteContact() {
  //   swal({
  //     title: 'Excluir contato',
  //     text: 'Tem certeza que deseja excluir este contato?',
  //     icon: 'warning',
  //     buttons: ['Cancelar', 'Excluir contato'],
  //     dangerMode: true,
  //   })
  //   .then(async (willDelete) => {
  //     if (!willDelete) return;

  //     try {
  //       // await api.delete(`/contacts/${user.id}`);
  //       toast.success('Contato excluido com sucesso!');
  //     } catch (err) {
  //       const { message = 'Um erro ocorreu ao excluir o contato. Por favor, tente novamente!' } = Object(err?.response?.data);
  //       toast.error(message);
  //     }
  //   });
  // }

  return (
    <>
      <Container>
        {isSelectingContact && <ContactProfileSkeleton />}
        {!isSelectingContact && (
          <>
            <Infos>
              <UserName>
                <div>
                  {user.real_estate_id
                    ? (
                      <a href="./" onClick={handleOpenContactInfoModal}>
                        <TextEllipsis width={window.matchMedia("(max-width: 1366px)").matches ? 100 : 200}>
                          {user.name}
                        </TextEllipsis>
                      </a>
                    )
                    : (
                      <TextEllipsis width={window.matchMedia("(max-width: 1366px)").matches ? 100 : 200}>
                        {user.name}
                      </TextEllipsis>
                    )
                  }
                </div>

                {user.real_estate_id ? (
                  <Check color={theme.colors.success} size="14" />
                ) : (
                  <a href="./" onClick={handleCheckRegistration}>
                    <TextEllipsis width={window.matchMedia("(max-width: 1366px)").matches ? 100 : 200}>
                      Checar cadastro
                    </TextEllipsis>
                  </a>
                )}

                {user.real_estate_info && (
                  <RealEstateButton
                    type="button"
                    onClick={handleGoToRealEstateContacts}
                    title="Ver contatos desta imobiliária"
                  >
                    <Users size="12" />
                    {user.real_estate_info.contacts_count}
                  </RealEstateButton>
                )}

                <EditIcon onClick={handleOpenEditContactModal} color={theme.colors.text} size="14" />
                {/* <TrashIcon onClick={handleDeleteContact} color={theme.colors.danger} size="14" /> */}
              </UserName>
              <UserPhone>
                <TextEllipsis width={window.matchMedia("(max-width: 1366px)").matches ? 100 : 200}>
                  {user.phone_number ? formatPhoneNumberIntl(`+${user.phone_number}`) : user.whatsapp_username ? `@${user.whatsapp_username}` : 'Número oculto'}
                </TextEllipsis>
                {/* <InfoIcon onClick={handleOpenContactInfoModal} color={theme.colors.text} size="14" /> */}
              </UserPhone>
              <UserPhone>
                <TextEllipsis width={window.matchMedia("(max-width: 1366px)").matches ? 100 : 200}>
                  Saida: {currentNumber ? `${currentNumber.label} (${currentNumber.phone_number})` : 'Não definido'}
                </TextEllipsis>
                <EditIcon onClick={handleOpenChangeSessionModal} color={theme.colors.text} size="14" />
              </UserPhone>
            </Infos>
          </>
        )}
      </Container>

      <EditContactModal
        isOpen={isEditContactModalOpen}
        onRequestClose={handleCloseEditContactModal}
        contactToEdit={user}
      />

      <ContactInfoModal
        isOpen={isContactInfoModalOpen}
        onRequestClose={handleCloseContactInfoModal}
        contact={user}
      />

      <ChangeSessionModal
        isOpen={isChangeSessionModalOpen}
        onRequestClose={handleCloseChangeSessionModal}
        contact={user}
      />
    </>
  );
}
